export const transferAssignStatusCollectionGuard =
  'GET /transfer-assign-statuses';
export const transferAssignStatusResourceGuard =
  'GET /transfer-assign-statuses/d+';
